import { jsx as _jsx } from "react/jsx-runtime";
import legalDocuments from '@phishtool/legal-documents';
import Legal from '~components/legal';
const ProofOfValueAgreement = () => (_jsx(Legal, { heading: "Proof of Value Agreement", content: legalDocuments.proofOfValueAgreement }));
export default ProofOfValueAgreement;
